module.exports = __webpack_public_path__ + "static/img/BMW.33a43ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/BMW.png
// module id = H4ib
// module chunks = 1